import DumbRegistrationHeadingSection from './RegistrationHeadingSection.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface RegistrationHeadingSectionI {
    /** Title to display, fed from the dictionary */
    title?: string;

    /** Subtitle to display, fed from the dictionary */
    subtitle?: string;

    /** Body to display, fed from the dictionary */
    body?: string;
    icon?: string;
}

/* -------------------------------- Component ------------------------------- */

/**
 * RegistrationHeadingSection
 *
 * Renders a display containing a title and descriptions of a form, normally
 * used at the top of a registration template.
 *
 * @param props RegistrationHeadingSectionI
 * @returns JSX.Element
 */
const RegistrationHeadingSection = ({
    icon,
    title,
    subtitle,
    body,
}: RegistrationHeadingSectionI) => (
    <DumbRegistrationHeadingSection
        title={title}
        subtitle={subtitle}
        body={body}
        icon={icon}
    />
);

/* --------------------------------- Export --------------------------------- */

export default RegistrationHeadingSection;
